import equipment_in_out from './equipment_in_out'
import equipment_in_out_workflow_dialog from './equipment_in_out/equipment_in_out_workflow_dialog'
import knowledge from './knowledge'
import pue from './pue'
import kpi from './kpi'
import kpiRecord from './kpiRecord'
import kpiResult from './kpiResult'
import dept from './dept'
import assessment from './assessment'
import sysroom from './sysroom'
import organization from './organization'

import sysroomNew from './sysroomNew'
import dcim from './dcim'

export default {
  equipment_in_out,
  equipment_in_out_workflow_dialog,
  knowledge,
  pue,
  kpi,
  kpiRecord,
  kpiResult,
  dept,
  assessment,
  sysroom,
  organization,
  sysroomNew,
  dcim,
}
